import { useMutation } from '@tanstack/react-query';
import { Services } from './services';
import { BaseContextAepType } from './types';

const useComments = () => useMutation((payload: BaseContextAepType) => Services.saveComments(payload));

export const Hooks = { useComments };
